<h-positioned-under-header
    ><section
        id="block-text-on-full-media"
        data-testid="block-text-on-full-media"
        hBindSPANavigationForCTA
        [hAnimateOnScroll]="{
            animate: blockMediaText.hasAnimation,
            threshold: 0.2
        }">
        <div
            class="cta-container"
            (click)="navigate()"
            [attr.href]="(!blockMediaText.media?.videoUrl && !blockMediaText.media?.mobileVideoUrl && ctaPath) || null"
            [style.cursor]="
                !blockMediaText.media?.videoUrl && !blockMediaText.media?.mobileVideoUrl && ctaPath
                    ? 'pointer'
                    : 'default'
            ">
            @if (blockMediaText.media) {
            <div
                class="media"
                [class.media-video]="blockMediaText.media?.videoUrl || blockMediaText.media?.mobileVideoUrl">
                <h-media-cta
                    [displayGradient]="true"
                    [isLightMode]="true"
                    [isFillMode]="true"
                    [showSoundControlButton]="true"
                    [media]="blockMediaText.media"
                    [preloadPoster]="shouldPreloadMedia">
                    <!-- Display gradient only if it's image, the video's grandient is handled in video.component -->
                    @if (!blockMediaText.media?.videoUrl && !blockMediaText.media?.mobileVideoUrl) {
                    <div class="gradient"></div>
                    } @if (blockMediaText.text) {
                    <div
                        class="text editorial-immersive"
                        [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
                        [innerHtml]="
                            blockMediaText.text
                                | resolveTokens : blockMediaText.tokens : anchorCustomAttributesList : anchorClasses
                                | trustHtml
                        "></div>
                    }</h-media-cta
                >
            </div>
            }
        </div>
    </section>
</h-positioned-under-header>
